module.exports = __webpack_public_path__ + "2e6abe8f7a835886356acbbe54adab1c.jpg";